export const state = {
  nuggets: [],
  nugget: null,
  related_nuggets: [],
  quiz_nuggets: [],
};
